"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderSingle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var popover_1 = require("../popover");
var input_1 = require("../input");
var icon_1 = require("../icon");
var text_1 = require("../text");
var CascaderBox_1 = require("./CascaderBox");
var CascadeMenu_1 = require("./CascadeMenu");
var CascaderSearch_1 = require("./CascaderSearch");
var form_1 = require("../form");
var i18n_1 = require("../i18n");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var noop_1 = require("../_util/noop");
var merge_event_props_1 = require("../_util/merge-event-props");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var defaultValueRender = function (options) {
    return options.map(function (_a, index) {
        var label = _a.label, value = _a.value;
        return (react_1.default.createElement(react_1.Fragment, { key: value + "-" + index },
            index !== 0 && " / ",
            label || value));
    });
};
exports.CascaderSingle = forward_ref_with_statics_1.forwardRefWithStatics(function CascaderSingle(props, ref) {
    var _a;
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = form_1.useDefaultValue(props, []), data = _b.data, value = _b.value, onChange = _b.onChange, onLoad = _b.onLoad, disabled = _b.disabled, changeOnSelect = _b.changeOnSelect, style = _b.style, className = _b.className, _c = _b.placeholder, placeholder = _c === void 0 ? t.pleaseSelect : _c, _d = _b.defaultOpen, defaultOpen = _d === void 0 ? false : _d, open = _b.open, _e = _b.onOpenChange, onOpenChange = _e === void 0 ? noop_1.noop : _e, _f = _b.placement, placement = _f === void 0 ? "bottom-start" : _f, _g = _b.placementOffset, placementOffset = _g === void 0 ? 5 : _g, _h = _b.closeOnScroll, closeOnScroll = _h === void 0 ? true : _h, escapeWithReference = _b.escapeWithReference, popupContainer = _b.popupContainer, overlayClassName = _b.overlayClassName, overlayStyle = _b.overlayStyle, clearable = _b.clearable, searchable = _b.searchable, filter = _b.filter, type = _b.type, expandTrigger = _b.expandTrigger, _j = _b.valueRender, valueRender = _j === void 0 ? defaultValueRender : _j, tips = _b.tips, bottomTips = _b.bottomTips, _k = _b.onScrollBottom, onScrollBottom = _k === void 0 ? noop_1.noop : _k, _l = _b.onSearch, onSearch = _l === void 0 ? noop_1.noop : _l;
    var _m = tslib_1.__read(react_1.useState(false), 2), hover = _m[0], setHover = _m[1];
    var _o = tslib_1.__read(use_default_1.useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _o[0], setIsOpened = _o[1];
    var _p = tslib_1.__read(react_1.useState(false), 2), focused = _p[0], setFocused = _p[1];
    var _q = tslib_1.__read(react_1.useState(false), 2), searching = _q[0], setSearching = _q[1];
    var _r = tslib_1.__read(react_1.useState(""), 2), searchValue = _r[0], setSearchValue = _r[1];
    var options = CascaderBox_1.getOptions(data, value);
    var Box = type === "menu" ? CascadeMenu_1.CascaderMenuBox : CascaderBox_1.CascaderBox;
    return (react_1.default.createElement(popover_1.Popover, { trigger: disabled ? "empty" : "click", visible: isOpened, onVisibleChange: setIsOpened, onExited: function () {
            setSearchValue("");
            setSearching(false);
        }, placement: placement || "bottom-start", placementOffset: placementOffset, closeOnScroll: closeOnScroll, escapeWithReference: escapeWithReference, popupContainer: popupContainer, overlayClassName: overlayClassName, overlayStyle: overlayStyle, overlay: function (_a) {
            var scheduleUpdate = _a.scheduleUpdate;
            if (searchValue) {
                return (react_1.default.createElement(CascaderSearch_1.CascaderSearch, { data: data, searchValue: searchValue, filter: filter, onChange: function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        onChange.apply(void 0, tslib_1.__spread(args));
                        setIsOpened(false);
                        setSearching(false);
                    }, scheduleUpdate: scheduleUpdate, changeOnSelect: changeOnSelect, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom, onSearch: onSearch }));
            }
            return (react_1.default.createElement(Box, { data: data, curValue: value, onLoad: onLoad, onSelect: onChange, onClose: function () { return setIsOpened(false); }, changeOnSelect: changeOnSelect, scheduleUpdate: scheduleUpdate, expandTrigger: expandTrigger, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom }));
        } },
        react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-cascader", className, (_a = {},
                _a[classPrefix + "-cascader--search"] = searchable,
                _a["is-disabled"] = disabled,
                _a)), style: style }, merge_event_props_1.mergeEventProps(props, {
            onMouseEnter: function () { return setHover(true); },
            onMouseLeave: function () { return setHover(false); },
        })),
            react_1.default.createElement("div", { className: classPrefix + "-cascader__input" },
                !searching && (react_1.default.createElement("div", { className: classPrefix + "-cascader__value" },
                    react_1.default.createElement(text_1.Text, { theme: focused ? "weak" : undefined }, valueRender(options)))),
                react_1.default.createElement(input_1.Input, { readonly: !searchable, autoComplete: "off", disabled: disabled, placeholder: value.length ? "" : placeholder, value: searching ? searchValue : "", onFocus: function () {
                        if (searchable) {
                            setFocused(true);
                            setIsOpened(true);
                            if (searchValue) {
                                setSearching(true);
                            }
                        }
                    }, onBlur: function () {
                        setFocused(false);
                        setSearching(false);
                    }, onChange: function (value) {
                        setSearchValue(value);
                    }, onInput: function (event) {
                        setSearching(!!event.currentTarget.value);
                    }, onClick: function (event) { return searchable && event.stopPropagation(); } })),
            clearable && !disabled && hover && value.length ? (react_1.default.createElement(icon_1.Icon, { type: "dismiss", onClick: function (event) {
                    event.stopPropagation();
                    onChange([], { event: event, options: [] });
                    setIsOpened(false);
                } })) : (react_1.default.createElement(icon_1.Icon, { type: "arrowdown" })))));
}, {
    defaultLabelAlign: "middle",
});
exports.CascaderSingle.displayName = "CascaderSingle";
//# sourceMappingURL=CascaderSingle.js.map